import * as React from "react";
import {cs} from "../../../../../../../../../../react/chain-services";
import "./table.scss";
import {DataTableD1} from "../../../../../../../../common/design2/data-table/data-table-d1";
import {Checkbox} from "../../../../../../../../common/design2/checkbox/checkbox";
import {UseState} from "../../../../../../../../../../react/use-state";
import {PageSize} from "../../../../../../../../common/design2/pagination-ui/page-size/page-size";
import {PageList} from "../../../../../../../../common/design2/pagination-ui/page-list/page-list";

export const Table = ({records, getCheckbox, loading, count, masterCheckbox}) => cs(
    ["pageSize", (_, next) => UseState({
        initValue: 10,
        // initValue: 3,
        next,
    })],
    ({pageSize}) => DataTableD1({
        darkRows: "even",
        className: "table-8uu",
        pageSize: pageSize.value,
        columns: Columns({
            count,
            masterCheckbox,
            loading,
        }),
        rows: records.map((r, i) => {
            return {
                key: r.address.address,
                // key: i,
                i,
                columns: [
                    {
                        render: () => Checkbox(getCheckbox(r)),
                    },
                    {
                        render: () => (
                            <>
                                {r.address.address}
                                {r.address.doNotMail ? <span className="do-not-mail" xd-qa-type="label" xd-qa-name={`${r.address.address} Do Not Mail`}> (Do Not Mail)</span> : ''}
                            </>
                        ),
                        sortValue: () => r.addressSortKey,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Street List "+r.address.address,
                        },
                    },
                    {
                        render: () => r.parentRecord.street.zip_code,
                        sortValue: () => r.parentRecord.street.zip_code,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Street List "+r.address.address+" Zip Code",
                        },
                    },
                ],
            };
        }),
        emptyAction: {
            label: loading ? "Loading..." : "No address(es) found",
        },
        getFooter: ({pagination, colCount}) => ({
            columns: [{
                colSpan: colCount,
                render: () => (
                    <div className="controls">
                        {records.length > 10 ? (
                            PageSize({state: pageSize, xdQaNamePrefix: "Build Street List"})
                        ) : (
                            <div className="spacer"/>
                        )}

                        {pagination.active && PageList({...pagination, xdQaNamePrefix: "Build Street List Addresses"})}

                        <div className="spacer"/>
                    </div>
                ),
            }],
        }),
    }),
);

const Columns = ({masterCheckbox, count, loading}) => [
    {
        width: "1%",
        className: "checkbox",
        render: () => Checkbox({
            ...masterCheckbox,
            xdQaName: "Build Street List Addresses Master Checkbox",
        }),

    },
    {
        width: "20%",
        label: "ADDRESS",

        subTitle: loading ? (
            `( Loading... )`
        ) : (
            `(${count.selected} of ${count.total} addresses selected)`
        ),

        className: "address",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Street List Address",
        },
    },
    {
        width: "1%",
        label: "ZIP CODE",
        className: "zip",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Street List Addresses Zip Code",
        },
    },
];